import * as Request from "common/utils/serverRequest";
import * as ServerHelper from "common/utils/serverHelper";
import * as serverPaths from "common/utils/serverPaths";
//-------------------------------------------------------------------------------------------------------------------------------
export function async_FeaturedAgentRequest(dispatch, officeId) {
    return async_widgetRequest(dispatch, officeId, serverPaths.featuredAgentRequestParams(officeId));
}
export function async_FeaturedListingRequest(dispatch, officeId) {
    return async_widgetRequest(dispatch, officeId, serverPaths.featuredListingRequestParams(officeId));
}
export function async_SpotlightListingRequest(dispatch, officeId) {
    return async_widgetRequest(dispatch, officeId, serverPaths.spotlightListingRequestParams(officeId));
}
export function async_widgetRequest(dispatch, officeId, url) {
    // Make the request and deal with the response
    return Request.getComponentJson(dispatch, url)
        .then((response) => handleSuccess(response), (error) => ServerHelper.handleResponseFailure(error));
}
function handleSuccess(response) {
    return response.json()
        .then((response) => {
        return Promise.resolve(response.url);
    }, () => {
        return Promise.reject("Unknown error interpreting response (1)");
    });
}
//-------------------------------------------------------------------------------------------------------------------------------
